import {
  fetchExamInfo,
} from "../../api/index";

export default {
  
  async FETCH_TEST_PLAN(context, payload) {
    try {
      const response = await fetchExamInfo(payload);
      context.commit("SET_TEST_PLAN", response.data);
      return response;
    }catch(error) {
      console.log(error);
    }
  },

};
